import { ObjectBuilder, MeshUtils, ScrollViewer3D, GridUtils, Rectangle3D, ButtonUtils, ControlState, InputUtils, Image3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
import { Logger } from "../../utils/Logger";
import { Keys } from "./keyboard/Keyboard3D";
import { text } from "../../TextResources";
import { runAsync } from "../../utils/AsyncUtils";
import { BroadcastManagerState as BMState } from "@dreamcam/web-sdk";
// import { VoiceToTextAnimationPanel } from "./VoiceToTextAnimationPanel"; //TODO: restore v2t
// import { Settings } from "../../settings/Settings"; //TODO: restore v2t
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Control } from "@babylonjs/gui/2D/controls/control.js";
import { TextWrapping } from "@babylonjs/gui/2D/controls/textBlock.js";
import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { UserType } from "../../interfaces/BroadcastInterfaces";
import { MeshName } from "../MeshName";
import { StackPanel } from "@babylonjs/gui/2D/controls/stackPanel.js";
import { BroadcastMenuTipsKeyboard } from "./BroadcastMenuTipsKeyboard";
import { Settings } from "../../settings/Settings";
import { StringUtils } from "../utils/StringUtils";
import { ScrollHandler } from "../ScrollHandler";
import { XRInputHelper } from "../XRInputHelper";
import { AppView } from "../AppView";
import { MenuPopupContainer } from "./MenuPopupContainer";
export class BroadcastMenuChat {
    constructor(menuMesh, keyboard, menuTipsKeyboardMesh, hideKeyboardComponent, 
    // voiceToTextAnimationPanel: VoiceToTextAnimationPanel, //TODO: restore v2t
    menuFunctions, callbacks) {
        this._messages = [];
        this._isGuest = true;
        this._isVisible = true;
        // public _seenVoiceToTextOnboarding = false; //TODO: restore v2t
        this._clientNickname = undefined;
        this._isMyMessage = (message) => {
            if (this._clientNickname && message.clientNickname) {
                return this._clientNickname === message.clientNickname;
            }
            else {
                return undefined;
            }
        };
        this._tipMenu = [];
        this._tipMenuEnabled = false;
        this._balance = 0;
        this._tipsKeyboard = null;
        this._getUserTypeColor = (message) => {
            switch (message.userType) {
                case UserType.System:
                    return Env.broadcast.menu.chat.text.systemColor;
                case UserType.StudioModel:
                    return Env.broadcast.menu.chat.text.modelColor;
                case UserType.Client:
                    switch (this._isMyMessage(message)) {
                        case false:
                            return Env.broadcast.menu.chat.text.clientColor;
                        case true:
                            return Env.broadcast.menu.chat.text.myColor;
                        default:
                            return undefined;
                    }
                default:
                    return undefined;
            }
        };
        this.addMessage = (message, isSpecial = false, forceColor = undefined) => {
            const cs = Env.broadcast.menu.chat;
            const color = forceColor ? forceColor : this._getUserTypeColor(message);
            if (!color) {
                Logger.error(`Unknown user's type: ${message.userType}`);
                return;
            }
            const textBlock = ObjectBuilder.createTextBlock3D(this._menuMesh, "message", `${message.userType === UserType.System ? "" : (message.clientNickname + ": ")}${message.message}`, {
                fontSize: cs.text.fontSize,
                color,
                textWrapping: TextWrapping.WordWrap,
                resizeToFit: true,
                textVerticalAlignment: Control.VERTICAL_ALIGNMENT_BOTTOM,
                textHorizontalAlignment: isSpecial ? Control.HORIZONTAL_ALIGNMENT_CENTER : Control.HORIZONTAL_ALIGNMENT_LEFT,
            });
            const textMessage = { textBlock };
            this._messages.push(textMessage);
            if (isSpecial) {
                const container = new Rectangle3D("messageContainer");
                container.cornerRadius = this._menuMesh.m2px(cs.text.cornerRadius);
                container.adaptHeightToChildren = true;
                container.thickness = 0;
                const stackPanel = new StackPanel("messageStackPanel");
                stackPanel.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
                stackPanel.background = cs.text.systemBackgroundColor;
                textBlock.paddingTopInPixels = this._menuMesh.m2px(cs.text.special.padding.top);
                textBlock.paddingBottomInPixels = this._menuMesh.m2px(cs.text.special.padding.bottom);
                stackPanel.addControl(textBlock);
                container.addControl(stackPanel);
                this._chatContainer.addControl(container);
            }
            else
                this._chatContainer.addControl(textBlock);
        };
        this.tipHasBeenSent = (tip) => {
            this.addMessage({
                userType: UserType.System,
                message: StringUtils.stringFormat(text.broadcast_menu_chat_tip, tip.clientNickname, tip.amount),
                clientNickname: tip.clientNickname
            }, true);
        };
        this._onHideKeyboardClickObserver = null;
        this._menuMesh = menuMesh;
        this._keyboard = keyboard;
        this._menuTipsKeyboardMesh = menuTipsKeyboardMesh;
        this._hideKeyboardComponent = hideKeyboardComponent;
        // this._voiceToTextAnimationPanel = voiceToTextAnimationPanel; //TODO: restore v2t
        this._menuFunctions = menuFunctions;
        this._callbacks = callbacks;
        const panel = this._addChatPanel(menuMesh);
        this._chatContainer = panel.container;
        this._chatInput = panel.inputControl;
        this._popUp = panel.popUp;
        this._scrollHandler = new ScrollHandler([MeshName.broadcastMenuPanelChat], this._menuMesh.m2px(Env.broadcast.menu.chat.scrollView.speed), (v) => {
            if (this._chatScrollViewer !== undefined)
                this._chatScrollViewer.verticalValue = Math.max(Math.min(this._chatScrollViewer.verticalValue + v / (this._chatScrollViewer.children[0].heightInPixels - this._chatScrollViewer.heightInPixels), 1), 0);
        });
        const pointerAddon = XRInputHelper.addPointerAddon(this._menuMesh);
        pointerAddon.onPointerOut.add(() => {
            this._scrollHandler.stopScroll();
        });
        //TODO: restore v2t
        // this._keyboard.onVisibilityChange.add((isVisible) => {
        //     if (isVisible && this._voiceToTextAnimationPanel.isVisible)
        //         this._voiceToTextAnimationPanel.hide();
        // });
        // this._keyboard.onVisibilityChange.add((v) => {
        //     this._hideKeyboardMesh.isVisible = v;
        // })
        this._keyboard.isVisible = false;
        // this._voiceToTextAnimationPanel.hide(); //TODO: restore v2t
        // this._keyboard.mesh.rotateAround(
        //     this._keyboard.mesh.position.add(Vector3.Up().scale(this._keyboard.height / 2)),
        //     Vector3.Right(), Env.broadcast.menu.keyboard.angleInDegrees * Math.PI / 180);
        // this._voiceToTextAnimationPanel.mesh.mesh.rotateAround(
        //     this._voiceToTextAnimationPanel.mesh.mesh.position.add(Vector3.Up().scale(this._voiceToTextAnimationPanel.mesh.height / 2)),
        //     Vector3.Right(), Env.broadcast.menu.keyboard.angleInDegrees * Math.PI / 180); //TODO: restore v2t
    }
    tipMenuItemHasBeenRequested(tipMenuItem) {
        this.addMessage({
            userType: UserType.System,
            message: StringUtils.stringFormat(text.broadcast_menu_tipMenu_chatMessage_line1, tipMenuItem.clientNickname, tipMenuItem.price),
            clientNickname: tipMenuItem.clientNickname
        }, true);
        this.addMessage({
            userType: UserType.System,
            message: StringUtils.stringFormat(text.broadcast_menu_tipMenu_chatMessage_line2, tipMenuItem.description),
            clientNickname: tipMenuItem.clientNickname
        }, true);
    }
    toysMenuItemPurchased(toysMenuItem) {
        this.addMessage({
            userType: UserType.System,
            message: toysMenuItem.duration === 0
                ? StringUtils.stringFormat(text.broadcast_menu_tipMenu_chatMessage_toyChatMessageZeroDuration, toysMenuItem.title, toysMenuItem.clientNickname)
                : StringUtils.stringFormat(text.broadcast_menu_tipMenu_chatMessage_toyChatMessageNonZeroDuration, toysMenuItem.title, toysMenuItem.duration, toysMenuItem.clientNickname),
            clientNickname: toysMenuItem.clientNickname
        }, true, Env.broadcast.menu.tipMenu.toysMenuItem.vibration.getToysMenuItemColor(toysMenuItem.vibration));
    }
    outputClientInfo(isGuest) {
        this._isGuest = isGuest;
        // this._micButton.isEnabled = !isGuest; //TODO: restore v2t
    }
    setCustomTipValue(customTipValue) {
        if (this._tipsInputControl) {
            this._tipsInputControl.text = `${customTipValue}`;
        }
    }
    connectKeyboard() {
        this._keyboard.control.connect(this._chatInput);
    }
    disconnectKeyboard() {
        this._keyboard.control.disconnect(this._chatInput);
    }
    _addChatPanel(menuMesh) {
        const ms = Env.broadcast.menu;
        const cs = ms.chat;
        const rootContainer = new Rectangle3D("chat_container");
        rootContainer.cornerRadius = this._menuMesh.m2px(ms.cornerRadius);
        rootContainer.background = ms.backgroundColor;
        rootContainer.clipChildren = true;
        rootContainer.thickness = 0;
        menuMesh.texture.addControl(rootContainer);
        const mainGrid = GridUtils.CreateGrid("chatGrid", cs.grid, this._menuMesh);
        mainGrid.paddingLeftInPixels = this._menuMesh.m2px(cs.grid.padding);
        mainGrid.paddingTopInPixels = this._menuMesh.m2px(cs.grid.padding);
        mainGrid.paddingRightInPixels = this._menuMesh.m2px(cs.grid.padding);
        mainGrid.paddingBottomInPixels = this._menuMesh.m2px(cs.grid.padding);
        rootContainer.addControl(mainGrid);
        this._chatScrollViewer = new ScrollViewer3D("chatScrollViewer");
        this._chatScrollViewer.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        this._chatScrollViewer.color = cs.scrollView.colors.background;
        this._chatScrollViewer.barColor = cs.scrollView.colors.bar;
        this._chatScrollViewer.hoverBarColor = cs.scrollView.colors.hoverBar;
        this._chatScrollViewer.pressedBarColor = cs.scrollView.colors.pressedBar;
        this._chatScrollViewer.verticalBarPaddingInPixels = {
            left: this._menuMesh.m2px(cs.scrollView.verticalBar.padding.left),
            right: this._menuMesh.m2px(cs.scrollView.verticalBar.padding.right),
            top: this._menuMesh.m2px(cs.scrollView.verticalBar.padding.top),
            bottom: this._menuMesh.m2px(cs.scrollView.verticalBar.padding.bottom)
        };
        this._chatScrollViewer.barSizeInPixels = this._menuMesh.m2px(cs.scrollView.verticalBar.size);
        mainGrid.addControl(this._chatScrollViewer, 0);
        let toysMenuButton = null;
        if (Settings.getInstance().broadcast.showToysMenuNotification && new Date(new Date(Date.now()).toISOString()).getTime() < new Date(cs.toysMenuNotification.cutOffDate).getTime()) {
            toysMenuButton = ButtonUtils.CreateImgButtonWithText("toysMenuNotification", { imageLayout: cs.toysMenuNotification.button, textLayout: cs.toysMenuNotification.text, text: text.broadcast_menu_chat_toysMenuNotification }, this._menuMesh);
            toysMenuButton.onClickObserver.add(() => {
                this._menuFunctions.setTipMenuVisibility(true, 1);
                mainGrid.removeControl(toysMenuButton);
                toysMenuButton = null;
                Settings.getInstance().broadcast.showToysMenuNotification = false;
                this._tipMenuButton.isToggled = true;
            });
            mainGrid.addControl(toysMenuButton, 1);
            const closeButton = ButtonUtils.CreateImgButton("toysMenuCloseNotificationButton", cs.toysMenuNotification.closeButton, this._menuMesh);
            closeButton.onClickObserver.add(() => {
                mainGrid.removeControl(toysMenuButton);
                toysMenuButton = null;
                closeButton.isVisible = false;
                Settings.getInstance().broadcast.showToysMenuNotification = false;
            });
            closeButton.isVisible = false;
            rootContainer.addControl(closeButton);
            toysMenuButton.onPointerEnterObservable.add(() => {
                closeButton.isVisible = true;
            });
            toysMenuButton.onPointerOutObservable.add(() => {
                closeButton.isVisible = false;
            });
            closeButton.onPointerEnterObservable.add(() => {
                toysMenuButton?.stateController.changeState("hover");
                closeButton.isVisible = true;
            });
            closeButton.onPointerOutObservable.add(() => {
                toysMenuButton?.stateController.changeState("normal");
                closeButton.isVisible = false;
            });
        }
        const chatContainer = new StackPanel("chat");
        chatContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        chatContainer.spacing = this._menuMesh.m2px(cs.spacing);
        this._chatScrollViewer.addControl(chatContainer);
        const lineContainer = new Container("");
        const line = new Rectangle3D("");
        line.thickness = 0;
        line.background = cs.dividerLine.background;
        line.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        line.heightInPixels = this._menuMesh.m2px(cs.dividerLine.height);
        lineContainer.addControl(line);
        mainGrid.addControl(lineContainer, 2);
        mainGrid.addControl(ObjectBuilder.createTextBlock3D(this._menuMesh, "", text.broadcast_menu_tips_header, cs.sendTips.header), 3);
        const tipsPanel = new StackPanel("chatTipsStackPanel");
        tipsPanel.isVertical = false;
        tipsPanel.adaptHeightToChildren = true;
        tipsPanel.spacing = this._menuMesh.m2px(cs.sendTips.spacing);
        tipsPanel.paddingBottomInPixels = this._menuMesh.m2px(cs.sendTips.padding);
        mainGrid.addControl(tipsPanel, 4);
        this._tipMenuButton = ButtonUtils.CreateImgToggleButtonWithText("chatTipMenuButton", { imageLayout: cs.sendTips.tipMenu.button, textLayout: cs.sendTips.tipMenu.text, text: text.broadcast_menu_tipMenu_startButton, toggledText: text.broadcast_menu_tipMenu_startButton }, this._menuMesh);
        this._tipMenuButton.onIsToggledChangedObservable.add(v => {
            const isEnabledNotEmpty = (this._tipMenuEnabled && this._tipMenu.length > 0) || (this._toysMenu !== undefined && this._toysMenu.some(x => x.modeDefined !== undefined));
            if (isEnabledNotEmpty) {
                if (v && toysMenuButton !== null) {
                    mainGrid.removeControl(toysMenuButton);
                    toysMenuButton = null;
                    Settings.getInstance().broadcast.showToysMenuNotification = false;
                }
                this._menuFunctions.setTipMenuVisibility(v);
                if (this._menuFunctions.getModelProfilePanelVisibility() && v) {
                    this._menuFunctions.setModelProfilePanelVisibility(false);
                    this._menuFunctions.updateModelProfilePanel();
                }
            }
            else {
                if (!v) {
                    this._menuFunctions.setTipMenuVisibility(false);
                }
                else {
                    this._popUp.show(this._tipMenuEnabled ? text.broadcast_menu_tipMenu_tipMenuEmpty : text.broadcast_menu_tipMenu_tipMenuDisabled);
                }
            }
        });
        this._tipMenuButton.onPointerUpObservable.add(() => {
            this.updateTipMenuButtonLayout();
        });
        tipsPanel.addControl(this._tipMenuButton);
        const sendTip = async (value) => {
            if (this._isGuest) {
                this._popUp.show(text.broadcast_menu_warning_nonAuthorizedUser);
                return;
            }
            if (this._balance < value) {
                this._popUp.show(text.broadcast_menu_warning_notEnoughTokens);
                return;
            }
            await this._callbacks.tipAsync(value);
        };
        for (const val of cs.sendTips.tips.values) {
            const tipButton = ButtonUtils.CreateImgButtonWithText(`chatTipButton_${val}`, { imageLayout: cs.sendTips.tips.imageLayout, textLayout: cs.sendTips.tips.textLayout, text: `${val}` }, this._menuMesh);
            tipButton.onClickObserver.add(() => sendTip(val));
            tipsPanel.addControl((tipButton));
        }
        this._tipsInputControl = InputUtils.CreateInput("tipsInput", cs.sendTips.customTip.input, this._menuMesh);
        this._tipsInputControl.placeholder = text.broadcast_menu_chat_customTip;
        if (Settings.getInstance().broadcast.customTipsAmount) {
            this._tipsInputControl.text = Settings.getInstance().broadcast.customTipsAmount.toString();
        }
        this._tipsInputControl.onPointerClickObservable.add(() => {
            setTimeout(() => {
                const tipsInputControl = this._tipsInputControl;
                if (this._tipsKeyboard === null) {
                    this._tipsKeyboard = new BroadcastMenuTipsKeyboard(this._menuTipsKeyboardMesh, () => { tipsInputControl.blur(); }, tipsInputControl);
                }
                this._tipsKeyboard.show();
                const x = (this._menuMesh.px2m(tipsInputControl._currentMeasure.left + tipsInputControl._currentMeasure.width) - cs.tipsKeyboard.width) / 2;
                const y = this._menuMesh.height / 2 + cs.tipsKeyboard.height / 2 - this._menuMesh.px2m(tipsInputControl._currentMeasure.top) + cs.tipsKeyboard.offset;
                this._tipsKeyboard.mesh.mesh.position = new Vector3(x, y, -0.02);
            });
        });
        this._tipsInputControl.onTextChangedObservable.add(() => {
            const tipsInputControl = this._tipsInputControl;
            let changedText = tipsInputControl.text;
            if (changedText.length > cs.sendTips.customTip.input.maxLength) {
                changedText = changedText.substring(0, changedText.length - 1);
            }
            while (!changedText.match(cs.sendTips.customTip.input.filter)) {
                changedText = changedText.replace(cs.sendTips.customTip.input.substitution, "");
            }
            tipsInputControl.text = changedText;
            const safeParseInt = (text, defaultValue) => {
                const result = Number.parseInt(text);
                return isNaN(result) ? defaultValue : result;
            };
            AppView.getInstance().customTip = safeParseInt(tipsInputControl.text, 0);
        });
        tipsPanel.addControl(this._tipsInputControl);
        const sendCustomTipButton = ButtonUtils.CreateImgButton("sendCustomTipButton", cs.sendTips.customTip.sendButton, this._menuMesh);
        sendCustomTipButton.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        sendCustomTipButton.isPointerBlocker = true;
        sendCustomTipButton.onClickObserver.add(async () => {
            const tip = Number.parseInt(this._tipsInputControl.text);
            if (!isNaN(tip)) {
                await sendTip(tip);
                Settings.getInstance().broadcast.customTipsAmount = tip;
            }
        });
        this._tipsInputControl.addControl(sendCustomTipButton);
        const clearInput = () => {
            inputControl.text = "";
        };
        const sendMessage = () => {
            const message = inputControl.text;
            // this._keyboard.isVisible = false; 
            // inputControl.blur();
            if (message === "")
                return;
            if (this._isGuest) {
                this._popUp.show(text.broadcast_menu_warning_nonAuthorizedUser);
                return;
            }
            clearInput();
            runAsync(async () => {
                await this._callbacks.sendMessageAsync(message);
            }, (error) => {
                Logger.error(error);
            });
        };
        const inputControl = InputUtils.CreateInput("input", cs.bottomPanel.input, this._menuMesh);
        let isInputFocused = false;
        const keyboardOwnerId = "broadcastMenuChat";
        inputControl.placeholder = text.broadcast_menu_chat_placeholder;
        // inputControl.onPointerDownObservable.add(() => {
        //     if (!this._seenVoiceToTextOnboarding && !Settings.getInstance().broadcast.doNotShowVoiceToTextOnboarding) {
        //         this._voiceToTextAnimationPanel.show("info");
        //     } else {
        //         this._keyboard.isVisible = true;
        //     }
        // });
        inputControl.onPointerDownObservable.add(() => {
            inputControl.focus();
        });
        inputControl.onFocusObservable.add(() => {
            isInputFocused = true;
            this._keyboard.setActiveOwner(keyboardOwnerId);
            //TODO: restore v2t
            // if (!this._seenVoiceToTextOnboarding && !Settings.getInstance().broadcast.doNotShowVoiceToTextOnboarding)
            // {
            //     this._voiceToTextAnimationPanel.show("info");
            // } else
            // {
            //     this._keyboard.isVisible = true;
            // }
            this._keyboard.isVisible = true; //TODO: restore v2t (REMOVE THIS LINE)
            inputControl.isCursorEnabled = true; //TODO: restore v2t (REMOVE THIS LINE)
        });
        inputControl.onBlurObservable.add(() => {
            isInputFocused = false;
            // if(this._keyboard.isVisible)
            //     this._keyboard.isVisible = false;
        });
        mainGrid.addControl(inputControl, 5);
        this._keyboard.control.connect(inputControl);
        inputControl.connectControl(this._keyboard.rootControl);
        this._keyboard.onEnterButtonClickedObservable.add(() => {
            if (!isInputFocused && this._keyboard.lastActiveOwner !== keyboardOwnerId)
                return;
            if (!isInputFocused) {
                inputControl.focus();
            }
            sendMessage();
        });
        //TODO: restore v2t
        // const micButtonContainer = new Ellipse("micContainer");
        // micButtonContainer.widthInPixels = this._menuMesh.m2px(cs.bottomPanel.mic.width + cs.bottomPanel.margin);
        // micButtonContainer.heightInPixels = this._menuMesh.m2px(cs.bottomPanel.mic.height + cs.bottomPanel.margin);
        // micButtonContainer.isPointerBlocker = true;
        // micButtonContainer.thickness = 0;
        // micButtonContainer.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        // micButtonContainer.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        // micButtonContainer.paddingLeftInPixels = this._menuMesh.m2px(cs.bottomPanel.margin);
        // micButtonContainer.paddingBottomInPixels = this._menuMesh.m2px(cs.bottomPanel.margin);
        // inputControl.addControl(micButtonContainer);
        // this._micButton = ButtonUtils.CreateImgButton("mic", cs.bottomPanel.mic, this._menuMesh);
        // micButtonContainer.addControl(this._micButton);
        this._inputDisabledIcon = new Image3D("input_disabled", cs.bottomPanel.inputDisabledIcon.src);
        this._inputDisabledIcon.widthInPixels = this._menuMesh.m2px(cs.bottomPanel.inputDisabledIcon.width + cs.bottomPanel.inputDisabledIcon.padding);
        this._inputDisabledIcon.heightInPixels = this._menuMesh.m2px(cs.bottomPanel.inputDisabledIcon.height + cs.bottomPanel.inputDisabledIcon.padding);
        this._inputDisabledIcon.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this._inputDisabledIcon.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;
        this._inputDisabledIcon.paddingLeftInPixels = this._menuMesh.m2px(cs.bottomPanel.inputDisabledIcon.padding);
        this._inputDisabledIcon.paddingBottomInPixels = this._menuMesh.m2px(cs.bottomPanel.inputDisabledIcon.padding);
        this._inputDisabledIcon.isVisible = this._state === BMState.SPY_SHOW;
        inputControl.addControl(this._inputDisabledIcon);
        const sendButton = ButtonUtils.CreateImgButton("send", cs.bottomPanel.send, this._menuMesh);
        sendButton.isPointerBlocker = true;
        sendButton.onPointerClickObservable.add(() => {
            sendMessage();
        });
        sendButton.isVisible = false;
        inputControl.addControl(sendButton);
        inputControl.onTextChangedObservable.add(() => {
            sendButton.isVisible = inputControl.text.length > 0;
        });
        inputControl.onDirtyObservable.add(() => {
            setTimeout(() => {
                const curVal = this._chatScrollViewer.verticalValue;
                this._chatScrollViewer.verticalValue = 0;
                this._chatScrollViewer.verticalValue = curVal;
                mainGrid.markAsDirty();
            }, 0);
        });
        const ps = Env.broadcast.menu.chat.popUp;
        const popUp = new MenuPopupContainer("pop_up", this._menuMesh, ps);
        popUp.widthInPixels = this._menuMesh.m2px(ps.width);
        popUp.heightInPixels = this._menuMesh.m2px(ps.height);
        popUp.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        popUp.hide();
        rootContainer.addControl(popUp);
        //TODO: restore v2t
        // let isV2TInitialized = false;
        // let wasLoading = false;
        // let recordingTimer: any = null;
        //
        // this._micButton.onPointerDownObservable.add(async () =>
        // {
        //     this._keyboard.isVisible = false;
        //     inputControl.blur();
        //     if(this._isGuest)
        //         return;
        //     this._seenVoiceToTextOnboarding = true;
        //     // this._voiceToTextAnimationPanel.isVisible = true;
        //     let requiresPermission = false;
        //     if (!isV2TInitialized)
        //     {
        //         this._voiceToTextAnimationPanel.show("loading");
        //         this._micButton.isEnabled = false;
        //         isV2TInitialized = await this._callbacks.initVoiceToTextSDKAsync((m) => inputControl.addChar(`${m} `), d => this._voiceToTextAnimationPanel.animateWaveform(d));
        //         wasLoading = true;
        //         this._micButton.isEnabled = true;
        //         this._micButton._forcePointerUp();
        //         requiresPermission = false;
        //     }
        //     if (!isV2TInitialized)
        //         this._voiceToTextAnimationPanel.show("error");
        //     else if (!requiresPermission)
        //     {
        //         this._voiceToTextAnimationPanel.show("speaking");
        //         wasLoading = false;
        //         this._callbacks.connectVoiceToTextSDK();
        //         recordingTimer = setTimeout(async () => {
        //             this._voiceToTextAnimationPanel.hide();
        //             this._micButton.isEnabled = false;
        //             if (isV2TInitialized)
        //                 await this._callbacks.disconnectVoiceToTextSDK(2000);
        //             this._micButton.isEnabled = true;
        //         }, 60000);
        //     }
        //
        // });
        // this._micButton.onPointerUpObservable.add(async () =>
        // {
        //     clearTimeout(recordingTimer);
        //     this._voiceToTextAnimationPanel.hide();
        //     if (wasLoading)
        //         return;
        //     this._micButton.isEnabled = false;
        //     if (isV2TInitialized)
        //         await this._callbacks.disconnectVoiceToTextSDK(2000);
        //     this._micButton.isEnabled = true;
        // });
        this._keyboard.control.onKeyPressObservable.add((key) => {
            if (!isInputFocused && this._keyboard.lastActiveOwner !== keyboardOwnerId)
                return;
            if (key !== Keys.enter) {
                return;
            }
            if (!isInputFocused) {
                inputControl.focus();
            }
            sendMessage();
        });
        // const hideKeyboardButton = ButtonUtils.CreateImgButton("hideKeyboard", cs.hideKeyboard, this._hideKeyboardMesh);
        // hideKeyboardButton.onPointerClickObservable.add(() => {
        //     setTimeout(() => {
        //         this._keyboard.isVisible = false;
        //         inputControl.blur();
        //     }, 0);
        // });
        // this._hideKeyboardMesh.texture.addControl(hideKeyboardButton);
        // // this._voiceToTextAnimationPanel.hide(); //TODO: restore v2t
        return { container: chatContainer, inputControl, popUp };
    }
    outputClientNickname(nickname) {
        this._clientNickname = nickname;
    }
    clear() {
        // this._modelNickname = undefined;
        this._chatInput.text = "";
        this._messages.length = 0;
        while (this._chatContainer.children.length > 0) {
            this._chatContainer.removeControl(this._chatContainer.children[0]);
        }
    }
    stateChanged(state, _isGuest, _reason) {
        this._state = state;
        // MeshUtils.setVisibility(this._menuMesh, this.isVisible && state !== BMState.SPY_SHOW);
        // console.log(`%c++++ stateChange(): this.isVisible=${this.isVisible}`, "background-color: yellow");
        MeshUtils.setVisibility(this._menuMesh, this.isVisible);
        this._chatInput.isEnabled = state !== BMState.SPY_SHOW;
        this._tipMenuButton.isEnabled = state !== BMState.SPY_SHOW;
        this._chatInput.placeholder = this._state !== BMState.SPY_SHOW ? text.broadcast_menu_chat_placeholder : text.broadcast_menu_chat_placeholder_spy;
        this._inputDisabledIcon.isVisible = this._state === BMState.SPY_SHOW;
        if (state === BMState.SPY_SHOW) {
            this._keyboard.isVisible = false;
            this._menuFunctions.setTipMenuVisibility(false);
        }
        else {
            this.updateTipMenuButtonLayout();
        }
    }
    outputTipMenu(tipMenuEnabled, tipMenu) {
        this._tipMenuEnabled = tipMenuEnabled;
        this._tipMenu = tipMenu;
        if (this._tipMenuButton) {
            this.updateTipMenuButtonLayout();
        }
    }
    outputToysMenu(toysMenu) {
        this._toysMenu = toysMenu;
        if (this._tipMenuButton) {
            this.updateTipMenuButtonLayout();
        }
    }
    updateTipMenuButtonLayout() {
        this._tipMenuButton.isToggled = this._menuFunctions.getTipMenuVisibility();
        if (this._tipMenuButton.isEnabled)
            this._tipMenuButton.stateController.changeState(this._tipMenuButton.isToggled ? ControlState.Toggled : ControlState.Normal);
    }
    outputClientBalance(value) {
        this._balance = value;
    }
    get isVisible() {
        return this._isVisible;
    }
    set isVisible(value) {
        if (this.isVisible === value)
            return;
        // this._seenVoiceToTextOnboarding = false; //TODO: restore v2t
        this._isVisible = value;
        // MeshUtils.setVisibility(this._menuMesh, value && this._state !== BMState.SPY_SHOW);
        MeshUtils.setVisibility(this._menuMesh, value);
        this._chatInput.isEnabled = this._state !== BMState.SPY_SHOW;
        this._chatInput.placeholder = this._state !== BMState.SPY_SHOW ? text.broadcast_menu_chat_placeholder : text.broadcast_menu_chat_placeholder_spy;
        this._tipMenuButton.isEnabled = this._state !== BMState.SPY_SHOW;
        this._inputDisabledIcon.isVisible = this._state === BMState.SPY_SHOW;
        // if (value && this._state !== BMState.SPY_SHOW) {
        if (value) {
            const appView = AppView.getInstance();
            if (this._tipsInputControl && appView.customTip > 0) {
                this._tipsInputControl.text = appView.customTip.toString();
            }
            this._onHideKeyboardClickObserver = this._hideKeyboardComponent.onClickObservable.add(() => this._chatInput.blur());
            this._scrollHandler.addThumbstickAxesChangedListener();
        }
        else {
            this._scrollHandler.releaseThumbstickAxesChangedListener();
            this._hideKeyboardComponent.onClickObservable.remove(this._onHideKeyboardClickObserver);
            this._onHideKeyboardClickObserver = null;
        }
    }
}
